import { useState } from "react";
import { toast } from "react-toastify";
import isEmail from "is-email/lib";
import apiCall from "../../api/api-call";
import fileUploadService from "../../services/fileupload.service";
import emailService from "../../services/email.service";

function ApplyJob(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [website, setWebsite] = useState("");
  const [file, setFile] = useState("");
  const [coverLetter, setCoverLetter] = useState("");

  // error state
  const [nameErr, setNameErr] = useState(false);
  const [emailErr, setEmailErr] = useState(false);
  const [fileErr, setFileErr] = useState("");

  const onChangeFile = async (file) => {
    const base64 = await fileUploadService.convertBase64(file);
    //console.log("base64: ", base64);
    setFile(base64);
  };

  const submitHandler = async (event) => {
    event.preventDefault();
    //console.log("submitting form");

    // dismissing all error toast
    toast.dismiss();

    let errorCtr = 0;

    // disabled button to prevent multiple submission
    const submitBtn = document.querySelector("button[type=submit]");
    submitBtn.setAttribute("disabled", "");

    // form validation
    if (name.trim() === "") {
      toast.error("Name is required.");
      setNameErr(true);
      errorCtr++;
    }

    if (email.trim() === "") {
      toast.error("Email is required.");
      setEmailErr(true);
      errorCtr++;
    } else if (!isEmail(email)) {
      toast.error("Email format is invalid.");
      setEmailErr(true);
      errorCtr++;
    }

    if (file.trim() === "") {
      toast.error("File is required.");
      setFileErr(true);
      errorCtr++;
    }

    if (errorCtr > 0) {
      submitBtn.removeAttribute("disabled");
      return;
    }

    // reset error state
    setNameErr(false);
    setEmailErr(false);
    setFileErr(false);

    const reqBody = {
      name,
      email,
      website,
      file,
      coverLetter,
      jobInfo: JSON.stringify(props.jobPostDetails),
    };

    await apiCall
      .postApplyJob(reqBody)
      .then((response) => {
        //console.log("response: ", response);
        //console.log("created job post");
        toast.success("Application successfully submitted!");

        // reset fields
        setName("");
        setEmail("");
        setWebsite("");
        setFile("");
        setCoverLetter("");

        // manual set to empty since not allowed in state
        document.querySelector("input[type=file]").value = "";
        submitBtn.removeAttribute("disabled");

        //console.log("sending email");
        emailService.sendEmail("applyJob", {
          name: name,
          email: email,
          emailTo: props.jobPostDetails.createdByUserEmail,
          jobTitle: props.jobPostDetails.title,
        });
      })
      .catch((error) => {
        console.log("error: ", error);
        toast.error("Error encountered. Please try again later.");
        submitBtn.removeAttribute("disabled");
      });
  };
  return (
    <div>
      <h4 className="mb-4">Apply For The Job</h4>
      <form onSubmit={submitHandler} noValidate>
        <div className="row g-3">
          <div className="col-12 col-sm-6">
            <input
              type="text"
              className={`form-control ${nameErr ? "is-invalid" : ""}`}
              placeholder="Your Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="col-12 col-sm-6">
            <input
              type="email"
              className={`form-control ${emailErr ? "is-invalid" : ""}`}
              placeholder="Your Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="col-12 col-sm-6">
            <input
              type="text"
              className="form-control"
              placeholder="Portfolio Website"
              value={website}
              onChange={(e) => setWebsite(e.target.value)}
            />
          </div>
          <div className="col-12 col-sm-6">
            <input
              type="file"
              className={`form-control bg-white ${fileErr ? "is-invalid" : ""}`}
              onChange={(e) => onChangeFile(e.target.files[0])}
              accept=".doc,.docx,.pdf,.ppt,.pptx,.rtf"
            />
          </div>
          <div className="col-12">
            <textarea
              className="form-control"
              rows="5"
              placeholder="Coverletter"
              value={coverLetter}
              onChange={(e) => setCoverLetter(e.target.value)}
            ></textarea>
          </div>
          <div className="col-12">
            <button className="btn btn-primary w-100" type="submit">
              Apply Now
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ApplyJob;
